import { ChangeDetectionStrategy, Component, OnInit, Input, Output,EventEmitter , ViewEncapsulation, Pipe } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { PaginationInstance } from '../../../../node_modules/ngx-pagination/dist/ngx-pagination.module';
import { LocationsService } from '../../_services/locations/locations.service';
import * as $ from 'jquery';

import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/pairwise';

@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None,
  providers: [LocationsService]
})
export class LocationsComponent implements OnInit {
  collection = [];
  cookies: Object;
  //config: any;
  locations: any;
  records: any;
  isDesc: boolean = false;
  column: string = 'serviceproviders';
  direction: number;
  serviceprovider: any;
  serviceproviders: string = '';
  config: any;
  dynamicCurrentPage: number = 1;
  filter: string;
  itemsPerPage:number = 10;
////

@Input() id: string;
@Input() maxSize: number = 7;
@Input()
get directionLinks(): boolean {
    return this._directionLinks;
}
set directionLinks(value: boolean) {
    this._directionLinks = !!value && <any>value !== 'false';
}
@Input()
get autoHide(): boolean {
    return this._autoHide;
}
set autoHide(value: boolean) {
    this._autoHide = !!value && <any>value !== 'false';
}

@Input() previousLabel: string = 'Previous';
@Input() nextLabel: string = 'Next';
@Input() screenReaderPaginationLabel: string = 'Pagination';
@Input() screenReaderPageLabel: string = 'page';
@Input() screenReaderCurrentLabel: string = `You're on page`;
//@Output() pageChange: EventEmitter<number> = new EventEmitter<number>();
@Output() pageChange: EventEmitter<number>;

private _directionLinks: boolean = true;
private _autoHide: boolean = false;

///////
  public filterText: string;
  public filterPlaceholder: string;
  public enableFilter: boolean;
  previousUrl: string;
  constructor(
    // private route: ActivatedRoute,
    private router: Router,
    private locationsService: LocationsService,
    private formBuilder: FormBuilder
  ) {

    this.enableFilter = true;
    this.filterText = "";
    this.filterPlaceholder = "Filter..";
    this.cookies = Cookie.getAll();
    if (this.cookies['TokenKey'] == undefined) {
      this.router.navigate(['']);
    }

    if (this.cookies['locationEdit'] == 1) {
      this.itemsPerPage = parseInt(this.cookies['itemPerPageLoc']);
      this.serviceproviders = this.cookies['changeService'];
      this.filter  = this.cookies['filterkeyUp'];
      this.filterText = this.cookies['filterkeyUp'];
      this.dynamicCurrentPage = parseInt(this.cookies['locationCurrentPage']);
      this.isDesc = false;
      if(this.cookies['filterCookieDir'] == -1){
        this.isDesc = true;
      }
      this.sort(this.cookies['filterCookieProp']);
      Cookie.set('locationEdit','0');
      Cookie.set('filterkeyUp','');
      Cookie.set('changeService','');
      Cookie.set('filterCookieProp', '');
      Cookie.set('filterCookieDir', '');
      Cookie.set('itemPerPageLoc', '');
    }

    this.config = {
      id: 'advanced',
      itemsPerPage: this.itemsPerPage,
      currentPage: this.dynamicCurrentPage
    };
    this.locationsService.getlocations().subscribe(
      res => {
        this.locations = res;
      }
    );

    this.locationsService.getServiceProviderType().subscribe(
      res => {
        this.serviceprovider = res;
      }
    );

  }

  ngOnInit() {
  }

  locationEdit(locationId){
    var d = $("#locationFilter").val().toString();
    var f = $("#locationChangeservice").val().toString();
    const i = $('#itemPerPageLoc').val().toString();
    Cookie.set('filterkeyUp', d);
    Cookie.set('changeService', f);
    Cookie.set('itemPerPageLoc', i);
    this.router.navigate(['locations/edit',locationId]);
  }

  changeService(event:any){
    Cookie.set('changeService', event.target.value);
  }

  filterKeyUp(event:any){
    Cookie.set('filterkeyUp', event.target.value);
  }

  sort(property) {
    this.isDesc = !this.isDesc; // change the direction
    if(this.isDesc){
      this.isDesc = this.isDesc; // change the direction
    }
    this.column = property;
    this.direction = this.isDesc ? 1 : -1;
  };

  itemPerPageLoc(event:any){
    Cookie.set('itemPerPageLoc', event.target.value);
  }

  /////////////
  @Input('data') meals: string[] = [];

  public filterSearch: string = '';
  // public maxSize: number = 7;
  // public directionLinks: boolean = true;
  // public autoHide: boolean = false;


  public labels: any = {
    previousLabel: 'Previous',
    nextLabel: 'Next',
    screenReaderPaginationLabel: 'Pagination',
    screenReaderPageLabel: 'page',
    screenReaderCurrentLabel: `You're on page`
  };

  private popped = [];



  onPageChange(number: any) {
    this.config.currentPage = number;
    var pageid = $(".current").text().replace("page ", "");
    // if (this.cookies['locationEdit'] == '1') {
    // var d = this.cookies['locationCurrentPage'];
    // $('.ngx-pagination li').each(function (i, li) {
    //   if (d == $.trim($(li).text().replace("page ", ""))) {
    //     $(li).css('background-color','red');
    //     alert($(li).text().replace("page ", ""));
    //   }

    // });
    // }
    Cookie.set('locationCurrentPage', number);
  }

  /////////////
  hideme: any = {};
  deletelocation(location) {
    $("#status_" + location.id).text('Please wait..');
    this.locationsService.deleteLocations(location.id).subscribe(
      res => {

      }
    );
    this.locationsService.getlocations().subscribe(
      res => {
        this.locations = res;
      }
    );
    //$("#status_" + location.id).text('Deleted');
    //this.hideme[location.id] = true;
  }

  exportToExcel() {
//    console.log('ddd');
    this.locationsService.exceldownload().subscribe(
      res => {
        window.location.href=res.file_path;
      }
    );
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/locations/locations.component.ts